import React from "react";
import { useEffect, useState, useRef, useMemo } from "react";
import "./propertiesagency.css";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import SelectBox from "../../input-components/selectBoxNew";
import {PropertyAddOwnerShipUrl,SearchContacts,ContactDetailsApi,generatesalesagreementPdfReport,generatePdfReport,generatetenantcheckreport,generateTenantAgreementPdfReport,ABNLookUpGuid,ABNLookUpbaseURL,updatepropertyownerfolio,getownerfoliobycode,searchfeestemplate,addupdateownerfoliofees,addupdatepaymentmethod,propertyDetails } from "../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../components/CommonSection/Cookie/Session";
import TextBox from "../../input-components/textbox";
import {makeRequestWithSpinner,DownloadFiletWithSpinner} from "../../../Utilities/client";
import { useSpinnerContext } from "../../../Utilities/SpinnerContext";
import { ActionStatus, isManualFilePath,eCreditDisbIntervel } from "../../../Utilities/enum";
import AddressInput from "../../input-components/address";
import Collapse from "../../input-components/collapse";
import { MultiOwnershipSchema } from "../../../components/CommonSection/Schema/schema";
import debounce from "lodash/debounce";
import {dynamicUrl} from "../../../Utilities/profileManagement";
import ToggleTabs from "../../input-components/toggleButtonTabs";
import { Checkbox } from "primereact/checkbox"; // Checkbox component
import {DownloadOutlined,PlusOutlined,UploadOutlined,EyeOutlined,CheckOutlined ,CloseOutlined ,DeleteOutlined,PercentageOutlined ,DollarOutlined  } from "@ant-design/icons";
import CustomModal from "../../input-components/Modal";
import { FormatDateView } from "../../../components/CommonSection/Utility/Utility";
import ShowValue from "../../input-components/ShowValue";
import { BiEnvelope, BiPhone } from "react-icons/bi";
import ToastAlert from "../../../components/CommonSection/ToastAlert/ToastAlert";
import { isNullOrEmpty } from "../../../components/CommonSection/Utility/ComponentFunction";
import { Table, Input, Select, Button, Space,Spin,Tooltip  } from "antd";



const initialValues = {
  owners: [
    {
      type: null,
      title: null,
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      ownerShipAddress: "",
      isPrimary: true,
      contactUniqueId: "",
      abn:"",
      companyName:""
    },
  ],
};

const PropertyOwnerShip = ({
  onDataRecive,
  handleparentsuccess,
  handleCurrentPage,
  getDocDetails,
  cancel,
  refreshData
}) => {
  const [userId, setUserId] = useState("");
  const [agencyID, setAgencyId] = useState("");
  const [agentId, setAgentId] = useState("");
  const [typeData, setTypeData] = useState([
    { value: 1, label: "Individual" },
    { value: 2, label: "Company" },
  ]);
  const [titleData, setTitleData] = useState([
    { value: 1, label: "Mr." },
    { value: 2, label: "Miss." },
    { value: 3, label: "Mrs." },
  ]);

  const navigate = useNavigate();
  const { showSpinner, hideSpinner } = useSpinnerContext();
  var url = new URL(window.location.href);
  var propertyUId = url.searchParams.get("propertyUID");
  var subTab = url.searchParams.get("subTab");

  const [fetching, setFetching] = useState(false);
  const [option, setOption] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);

  const [contactId, setContactId] = useState(0);
  const [tabValue, setTabValue] = useState("ownership");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [documentUrl, setDocumentUrl] = useState("");
  const [ownerFolioDetails, setOwnerFolioDetails] = useState({
    totalMoneyLimit: "",
    balanceLimit: "",
    disbursementIntervel: "",
    nextDisbursementDate: "",
    withholdAmount: "",
    withholdReason: "",
    clientAccess: false,
    id: null
  });
  const ToastRef = useRef();
  const [purpose, setPurpose] = useState(1);
    const eFeeCaluclationTypeOptions = [
        { label: "Off", value: eCreditDisbIntervel.Off },
        { label: "Weekly", value: eCreditDisbIntervel.Weekly },
        { label: "Fortnightly", value: eCreditDisbIntervel.Fortnightly },
        { label: "Twice Monthly", value: eCreditDisbIntervel.TwiceMonthly },
        { label: "Monthly", value: eCreditDisbIntervel.Monthly },
      ];
        
      const clientAccesstabs = [
        { label: 'Disable', value: 1 },
        { label: 'Enable', value: 2 },
        ];
    const [feeTemplates, setFeeTemplates] = useState([]); // API fee template list
    const [folioFees, setFolioFees] = useState([]);
      const [draftRows, setDraftRows] = useState([{
        feeTemplate: null,
        amount: ""
      }]);
      const ePaymentModes = [
        { value: 1, label: "Cash" },
        { value: 2, label: "Cheque" },
        { value: 3, label: "Card" },
        { value: 4, label: "EFT" }
    ];
          const [paymentMethods, setPaymentMethods] = useState([]);
        const [getDetails, setGetDetails] = useState(null);
    
  useEffect(() => {
    const retrieveData = async () => {
      try {
        const userData = GetCookie("@UserData");
        if (userData) {
          const parsedData = JSON.parse(userData);
          setUserId(parsedData.userId);
          setAgencyId(parsedData.agencyID);
          setAgentId(parsedData.agentId);
          getPropertyDetails(propertyUId)
        }
      } catch (error) {
        console.error("Error retrieving data from AsyncStorage:", error);
      }
    };
    retrieveData();
  }, [userId]);





  useEffect(() => {
    if (subTab) {
      setTabValue("agreement");
    }
  }, []);

  const {
    errors,
    values,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setFieldError,
    setValues,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: MultiOwnershipSchema,
    onSubmit: (values, action) => {
      handleFinalSubmit();
    },
  });

  const handleFinalSubmit = () => {
    const contacts = values.owners.map((owner, index) => {
      const contact = {
        Address: owner.ownerShipAddress,
        FirstName: owner.firstName,
        LastName: owner.lastName,
        Email: owner.email,
        MobileNumber: owner.phone,
        ContactType: owner.type,
        Title: owner.title,
        ContactUniqueId: owner.contactUniqueId,
        IsPrimary: owner.isPrimary || false,
        ABN: owner.abn,
        CompanyName: owner.companyName
      };
      return contact;
    });
console.log(getDetails,'getDetails')
    const formData = {
      AgencyId: agencyID,
      AgentId: getDetails?.agentId !== null ? getDetails?.agentId : agentId,
      PropertyUniqueId: propertyUId ? propertyUId : 0,
      UserId: userId,
      Contacts: contacts,
    };

    const url = PropertyAddOwnerShipUrl;
    makeRequestWithSpinner(showSpinner, hideSpinner, url, "post", formData)
      .then((returnData) => {
        if (returnData.status === ActionStatus.Successfull) {
          debugger;
          getPropertyDetails(propertyUId)
          setTabValue("agreement");
        } else {
          //handleparentsuccess(["error", returnData.message]);
        }
      })
      .catch((error) => {
        //handleparentsuccess(["error", error.message]);
      });
  };

   const getPropertyDetails = (value,rent) => {
          const baseUrl = propertyDetails;
          const apiUrl = `${baseUrl}?propertyID=${value}`;
          makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
              .then((response) => {
                  if (response.status === ActionStatus.Successfull) {
                    let getDetails = response.object;
                      setGetDetails(response.object);
                      viewOwnerFoliodetails(getDetails.ownerAccountFolio);
                      getsearchfeestemplate(agencyID,1)
                      if (getDetails) {
                        if (getDetails?.contactlistModel?.length > 0) {
                          const mappedValues = {
                            owners: getDetails?.contactlistModel.map((item) => ({
                              type: item.contactType || null,
                              title: item.title || null,
                              firstName: item.firstName || "",
                              lastName: item.lastName || "",
                              phone: item.phone || "",
                              email: item.contactEmail || "",
                              ownerShipAddress: item.address || "",
                              isPrimary: item.isPrimary || false,
                              contactUniqueId: item.contactUId || "",
                              abn: item.companyName || "",
                              companyName: item.companyName || ""
                            })),
                          };
                          setValues(mappedValues);
                        }
                  
                      }
                  } else {
                      //handleparentsuccess(["warn", response.data.message]);
                  }
              })
              .catch((error) => {
                  //handleparentsuccess(["error", error]);
              });
      };

      const onwerFolioDetails = getDetails?.ownerFolioDetails

  const getTypeData = (selectedValue) => {
    return typeData.find((item) => item.value === selectedValue);
  };

  const handleCancel = () => {
    var url = new URL(window.location.href);
    var propertyUId = url.searchParams.get("propertyUID");
    if (propertyUId) {
      handleCurrentPage("Overview");
      cancel(); 
    } 
  };
  useEffect(() => {
    agentUIDRef.current = agentId;
  }, [agentId]);

  const agentUIDRef = useRef(agentId);

  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      setOption([]);
      setFetching(true);
      let data = {
        Search: value,
        RecordsPerPage: 10,
        PageNo: 1,
        AgentID: agentUIDRef.current,
      };

      makeRequestWithSpinner(
        showSpinner,
        hideSpinner,
        SearchContacts,
        "post",
        data
      )
        .then((response) => {
          const transformedData = response.list.map((item) => ({
            value: item.id,
            label: item.name,
            uid: item.uid,
          }));
          setOption(transformedData);
          setFetching(false);
        })
        .catch((error) => setFetching(false));
    };

    return debounce(loadOptions, 800); // Debounce time of 800ms
  }, []);

  const handleSearchChange = (e, value, index) => {
    console.log(value, index,'value, index')
    if (value.length > 0) {
      const label = value.map((item) => item.label).join(",");
      const values = value.map((item) => item.value).join(",");
      const uid = value[0].uid;
      GetContactDetails(uid, index);
      setFieldValue("contactId", values);
      setFetching("propertyName", label);
      setContactId(values);
      debounceFetcher(value);
    }
  };

  const GetContactDetails = (contactUniqueId, ownerIndex) => {
    const baseUrl = ContactDetailsApi;
    const apiUrl = `${baseUrl}?contactUniqueId=${contactUniqueId}`;
    makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
      .then((response) => {
        if (response.status === ActionStatus.Successfull) {
          let data = response.object;
          setFieldValue(`owners[${ownerIndex}].firstName`, data.firstName);
          setFieldValue(`owners[${ownerIndex}].lastName`, data.lastName);
          setFieldValue(`owners[${ownerIndex}].phone`, data.mobileNumber);
          setFieldValue(`owners[${ownerIndex}].email`, data.email);
          setFieldValue(`owners[${ownerIndex}].type`, data.contactType);
          setFieldValue(`owners[${ownerIndex}].title`, data.title);
          setFieldValue(
            `owners[${ownerIndex}].contactUniqueId`,
            data.contactUniqueId
          );
        } else {
          handleparentsuccess(["warn", response.data.message]); // Show warning if response is not successful
        }
      })
      .catch((error) => {
        handleparentsuccess(["error", error.message]); // Handle any errors during the request
      });
  };

  const tabs = [
    { label: "Ownership", value: "ownership" },
    { label: "Agreement", value: "agreement" },
    { label: "Folio", value: "folio" },
  ];

  const handleTabChange1 = (activeTab) => {
    setTabValue(activeTab);
  };

  const handleAddOwner1 = () => {
    const newOwner = {
      type: null,
      title: null,
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      ownerShipAddress: "",
      isPrimary: false,
      contactUniqueId: "",
      abn:"",
      companyName:""
    };

    setFieldValue("owners", [...values.owners, newOwner]);
  };

  const handleOwnerChange = (index, field, value) => {
    const ownersArray = values.owners || [];
    while (ownersArray.length <= index) {
      ownersArray.push({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        isPrimary: false,
        contactUniqueId: "",
        ownerShipAddress: "",
      });
    }

    if (field === "isPrimary") {
      if (!value) {
        // Prevent unchecking the only primary owner
        const primaryCount = ownersArray.filter((owner) => owner.isPrimary).length;
        if (primaryCount === 1) {
          ToastRef.current.notify(["error", "At least one owner must be set as primary."]);
          return;
        }
      }

      ownersArray.forEach((owner, i) => {
        owner.isPrimary = i === index ? value : false;
      });
    } else {
      ownersArray[index][field] = value; // Update specific field
    }
    setFieldValue("owners", ownersArray);
  };

  const recentSalesData = [
    { key: "1", title: "Management Agreement", createdAt: "1/15/12" },
    { key: "2", title: "Residential Tenancy Agreement", createdAt: "5/7/16" },
    {
      key: "3",
      title: "Exclusive Sales Agency Agreement",
      createdAt: "1/15/12",
    },
  ];

  const handleDownload = (record, preview, getDocDetails) => {
    const matchedDocument = getDocDetails.find(
      (doc) => doc.sAgreementType === record.title
    );
    if (record.title === "Management Agreement") {
      if (matchedDocument.isManuallyAdded) {
        const fileUrl = `${isManualFilePath}${matchedDocument.agreementFilePath}`;
        window.open(fileUrl, "_blank");
      } else {
        handleAgreementDownload(propertyUId, preview);
      }
    } else if (record.title === "Tenant check") {
      if (matchedDocument.isManuallyAdded) {
        const fileUrl = `${isManualFilePath}${matchedDocument.agreementFilePath}`;
        window.open(fileUrl, "_blank");
      } else {
        handleTenantDownload(propertyUId);
      }
    } else if (record.title === "Residential Tenancy Agreement") {
      if (matchedDocument.isManuallyAdded) {
        const fileUrl = `${isManualFilePath}${matchedDocument.agreementFilePath}`;
        window.open(fileUrl, "_blank");
      } else {
        handleTenantAgreementDownload(propertyUId, preview);
      }
    } else if (record.title === "Exclusive Sales Agency Agreement") {
      if (matchedDocument.isManuallyAdded) {
        const fileUrl = `${isManualFilePath}${matchedDocument.agreementFilePath}`;
        window.open(fileUrl, "_blank");
      } else {
        handleSaleAgreementDownload(propertyUId, preview);
      }
    }
  };

  const handleTenantAgreementDownload = (record, preview) => {
    const formData = {
      PropertyUId: record,
    };
    DownloadFiletWithSpinner(
      showSpinner,
      hideSpinner,
      generateTenantAgreementPdfReport,
      "post",
      formData,
      null,
      false
    )
      .then((returnData) => {
        if (returnData != null) {
          if (preview) {
            setDocumentUrl(returnData);
            setIsModalVisible(true);
          } else {
            window.open(returnData, "_blank");
          }
        } else {
          ToastRef.current.notify(["error", "Internal Server Error"]);
        }
      })
      .catch((error) => {
        ToastRef.current.notify(["error", error.message]);
      });
  };

  const handleSaleAgreementDownload = (record, preview) => {
    const formData = {
      PropertyUId: record,
    };
    DownloadFiletWithSpinner(
      showSpinner,
      hideSpinner,
      generatesalesagreementPdfReport,
      "post",
      formData,
      null,
      false
    )
      .then((returnData) => {
        if (returnData != null) {
          if (preview) {
            setDocumentUrl(returnData);
            setIsModalVisible(true);
          } else {
            window.open(returnData, "_blank");
          }
        } else {
          ToastRef.current.notify(["error", "Internal Server Error"]);
        }
      })
      .catch((error) => {
        ToastRef.current.notify(["error", error.message]);
      });
  };

  const handleAgreementDownload = (record, preview) => {
    const formData = {
      PropertyUId: record,
    };
    DownloadFiletWithSpinner(
      showSpinner,
      hideSpinner,
      generatePdfReport,
      "post",
      formData,
      null,
      false
    )
      .then((returnData) => {
        if (returnData != null) {
          if (preview) {
            setDocumentUrl(returnData);
            setIsModalVisible(true);
          } else {
            window.open(returnData, "_blank");
          }
        } else {
          ToastRef.current.notify(["error", "Internal Server Error"]);
        }
      })
      .catch((error) => {
        ToastRef.current.notify(["error", error.message]);
      });
  };

  const handleTenantDownload = (records, preview) => {
    const formData = {
      AgencyId: getDetails.agencyId,
      UserId: records.userId,
    };
    DownloadFiletWithSpinner(
      showSpinner,
      hideSpinner,
      generatetenantcheckreport,
      "post",
      formData,
      null,
      false
    )
      .then((returnData) => {
        if (returnData != null) {
          if (preview) {
            setDocumentUrl(returnData);
            setIsModalVisible(true);
          } else {
            window.open(returnData, "_blank");
          }
        } else {
          ToastRef.current.notify(["error", "Internal Server Error"]);
        }
      })
      .catch((error) => {
        ToastRef.current.notify(["error", error.message]);
      });
  };

  const handleUploadAgreement = (rowData) => {
    if (rowData.title === "Management Agreement") {
      dynamicUrl(
        navigate,
        "UploadAgreementManagement" +
          `?propertyUID=${propertyUId}&propertyId=${getDetails.propertyId}`
      );
    } else if (rowData.title === "Residential Tenancy Agreement") {
      dynamicUrl(
        navigate,
        "UploadAgreementTenant" +
          `?propertyUID=${propertyUId}&propertyId=${getDetails.propertyId}`
      );
    } else {
      dynamicUrl(
        navigate,
        "UploadAgreement" +
          `?propertyUID=${propertyUId}&propertyId=${getDetails.propertyId}`
      );
    }
  };

  const handleAgreement = (rowData) => {
    if (rowData.title === "Management Agreement") {
      dynamicUrl(
        navigate,
        "agreementtabs" +
          `?propertyUID=${propertyUId}&agencyId=${
            getDetails.agencyId
          }&properties=${true}`
      );
    }
    if (rowData.title === "Residential Tenancy Agreement") {
      dynamicUrl(
        navigate,
        "tenancyagreement" +
          `?propertyUID=${propertyUId}&agencyId=${getDetails.agencyId}&properties=true`
      );
    }
    if (rowData.title === "Exclusive Sales Agency Agreement") {
      dynamicUrl(
        navigate,
        "SaleAgreementTabs" +
          `?propertyUID=${propertyUId}&agencyId=${getDetails.agencyId}&properties=true`
      );
    }
  };

  const columns = [
    { title: "Title", dataIndex: "title", key: "title" },
    { title: "Created At", dataIndex: "createdAt", key: "createdAt" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => {
        const isMatched = getDocDetails?.some(
          (agreement) => agreement.sAgreementType === record.title
        );

        return (
          <div style={{ display: "flex" }}>
            {!isMatched ? (
              <>
                <PlusOutlined
                  title="Add Agreement"
                  style={{
                    fontSize: "20px",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleAgreement(record)}
                />
                <UploadOutlined
                  title="Upload Agreement"
                  style={{
                    fontSize: "20px",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleUploadAgreement(record)}
                />
              </>
            ) : (
              <>
                <DownloadOutlined
                  title="Download Agreement"
                  style={{
                    fontSize: "20px",
                    marginRight: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleDownload(record, "", getDocDetails)}
                />
                <EyeOutlined
                  title="Preview"
                  style={{ fontSize: "20px", cursor: "pointer" }}
                  onClick={() =>
                    handleDownload(record, "preview", getDocDetails)
                  }
                />
              </>
            )}
          </div>
        );
      },
    },
  ];

  const handleNextStep = () => {
    handleCurrentPage("Listings");
  };

  const handleSubmitFees = () => {
    handleCurrentPage("Listings");

    dynamicUrl(
      navigate,
      "propertiesList" +
        `?propertyUID=${getDetails.propertyUniqueID}&tab=${"photos"}`
    );
  };

  const closePreview = () => {
    setIsModalVisible(false);
  };

  const handleAgreementNext = () => {
    setTabValue("folio");
  };

  const handleDeleteOwner = (index) => {
    const updatedOwners = values.owners.filter((_, i) => i !== index);
    setFieldValue("owners", updatedOwners);
  };
  
  const handleABNLoopup = (event,index) => {
      const abnNumber = event;
  
      handleBlur(event);
      if (!isNullOrEmpty(abnNumber)) {
        const url = `${ABNLookUpbaseURL}/AbnDetails.aspx?abn=${abnNumber}&guid=${ABNLookUpGuid}`;
        makeRequestWithSpinner(showSpinner, hideSpinner, url, "get")
          .then((returnData) => {
            const jsonString = returnData.match(/\{.*\}/)[0];
            const parsedData = JSON.parse(jsonString.slice(jsonString.indexOf("{")));
            if (!isNullOrEmpty(parsedData.Abn)) {
              const updatedOwners = [...values.owners];
              updatedOwners[index].companyName = parsedData.EntityName || "";
              setFieldValue("owners", updatedOwners);
            } else {
              setFieldError(`owners[${index}].abn`, "Invalid ABN number");
              ToastRef.current.notify(["error", "Invalid ABN"]);

            }
          })
          .catch((error) => {
            setFieldError(`owners[${index}].abn`, "Error fetching ABN details");
            ToastRef.current.notify(["error", error.message]);

          });
      }
    };
  
    const handleStatClick = (selectedPurpose) => {
      setPurpose(selectedPurpose);
    };
    

      const handleUpdatePropertyOwnerfolio = () => {
                const payload = {
                  Id: ownerFolioDetails.id,
                  WithholdAmount: ownerFolioDetails.withholdAmount,
                  WithholdReason: ownerFolioDetails.withholdReason,
                  ClientAccess: ownerFolioDetails.clientAccess,
                  DisbursementIntervel: ownerFolioDetails.disbursementIntervel,
                  TotalMoneyLimit: ownerFolioDetails.totalMoneyLimit,
                  BalanceLimit: ownerFolioDetails.balanceLimit,
                };
              
                makeRequestWithSpinner(showSpinner, hideSpinner, updatepropertyownerfolio, "post", payload)
                  .then((res) => {
                    if (res.status === 1) {
                      ToastRef.current.notify(["success", res.message]);
                      setPurpose(2)
                    } else {
                      ToastRef.current.notify(["error", res.message]);
                    }
                  })
              };

                const handleUpdatePropertyOwnerfolioFee = () => {
                          const payload = {
                              FolioFees: folioFees.map(({ FeeTemplateId, Amount, PropertyId }) => ({
                                Id: 0,
                                FeeTemplateId,
                                Amount,
                                PropertyId,
                              })),
                              AccountFolio: onwerFolioDetails.ownerAccountFolio
                            };
                          makeRequestWithSpinner(showSpinner, hideSpinner, addupdateownerfoliofees, "post", payload)
                            .then((res) => {
                              if (res.status === 1) {
                                ToastRef.current.notify(["success", res.message]);
                                setPurpose(3)
                              } else {
                                ToastRef.current.notify(["error", res.message]);
                              }
                            })
                        };
                        


               const viewOwnerFoliodetails = (value) => {
                      const baseUrl = getownerfoliobycode;
                      const apiUrl = `${baseUrl}?FolioCode=${value}`;
                      makeRequestWithSpinner(showSpinner, hideSpinner, apiUrl, "get")
                          .then((response) => {
                              if (response.status === ActionStatus.Successfull) {
                                  const data = response.object;
                                  setOwnerFolioDetails({
                                    totalMoneyLimit: data.totalMoneyLimit ?? "",
                                    balanceLimit: data.balanceLimit ?? "",
                                    disbursementIntervel: data.disbursementIntervel ?? "",
                                    nextDisbursementDate: data.nextDisbursementDate ?? "",
                                    withholdAmount: data.withholdAmount ?? "",
                                    withholdReason: data.withholdReason ?? "",
                                    clientAccess: data.clientAccess ?? false,
                                    id: data.id ?? null
                                  });
              
                                  const mappedFees = data.fees?.map(f => ({
                                      Id: f.folioFeesId,
                                      FeeTemplateId: f.feeTemplateId,
                                      Amount: f.amount,
                                      PropertyId: data.propertyId,
                                      FeeTemplateName: f.name,
                                      Account: f.account,
                                      FeeTrigger: f.sFeeType,
                                      calculationType: f.calculationType
                                    })) || [];
                                    setFolioFees(mappedFees);
                            
                                    // Set payment methods
                                    const mappedPayments = data.paymentMethods?.map(p => ({
                                      method: p.paymentMethod,
                                      payee: p.paymentMethod === 2 ? p.chequePayeeName : p.accountName,
                                      bsb: p.accountBSB ?? "",
                                      account: p.accountNumber ?? "",
                                      split: p.split ?? 0,
                                      isPercentage: p.splitType === 1
                                    })) || [];
              
                                    // Check if it's only one payment method and split is 0, then set it to 100
                                  if (mappedPayments.length === 1 && mappedPayments[0].split === 0) {
                                      mappedPayments[0].split = 100;
                                  }
                                    setPaymentMethods(mappedPayments);
              
                              } else {
                                  //handleparentsuccess(["warn", response.data.message]);
                              }
                          })
                          .catch((error) => {
                              //handleparentsuccess(["error", error]);
                          });
                  };
              
                    const getsearchfeestemplate = (value,key) => {
                                      const baseUrl = searchfeestemplate;
                  
                                      let payload = {
                                          AgencyId : value,
                                          ChargingTo: key
                                      }
                                      makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post",payload)
                                          .then((response) => {
                                              if (response.status === ActionStatus.Successfull) {
                                                  const data = response.list.map((item) => ({
                                                      ...item,
                                                      label: item.nameWithType,
                                                      value: item.id,
                                                    }));
                                                    setFeeTemplates(data);
                                              } else {
                                                  //handleparentsuccess(["warn", response.data.message]);
                                              }
                                          })
                                          .catch((error) => {
                                              //handleparentsuccess(["error", error]);
                                          });
                                  };
                  
                                  const handleFeeTemplateSelect = (idx, val) => {
                                      // Check if this feeTemplate is already added
                                      const alreadyExists = folioFees.some(f => f.FeeTemplateId === val.id);
                                      if (!alreadyExists) {
                                        const newFee = {
                                          Id: 0,
                                          FeeTemplateId: val.id,
                                          Amount: 0,
                                          PropertyId: getDetails?.propertyId,
                                          FeeTemplateName: val.name,
                                          Account: val.account,
                                          FeeTrigger: val.sFeeType,
                                          calculationType : val.calculationType 
                                        };
                                        setFolioFees((prev) => [...prev, newFee]);
                                      }
                                    };
                                    
                                    // 4. Remove Fee Row
                                    const handleRemoveFee = (index, type = "folio") => {
                                      if (type === "folio") {
                                        setFolioFees((prev) => prev.filter((_, i) => i !== index));
                                      } else {
                                        setDraftRows((prev) => prev.filter((_, i) => i !== index));
                                      }
                                    };
                                    
                                    const handleAddNewDraftRow = () => {
                                      setDraftRows((prev) => [...prev, { feeTemplate: null, amount: "" }]);
                                    };
                  

                                    const handleAddPaymentMethod = () => {
                                      setPaymentMethods((prev) => {
                                        const totalSplit = prev.reduce((acc, p) => acc + (p.isPercentage ? (p.split || 0) : 0), 0);
                                        const remaining = 100 - totalSplit;
                                        return [...prev.map(p => ({ ...p })), { method: 4, payee: "", bsb: "", account: "", split: prev.length === 0 ? 100 : 0, isPercentage: true }];
                                      });
                                    };
                                    
                                    // 4. Remove Row
                                    const handleRemovePaymentMethod = (index) => {
                                      setPaymentMethods((prev) => prev.filter((_, i) => i !== index));
                                    };
                                    const updateField = (idx, field, value) => {
                                      const updated = [...paymentMethods];
                                      updated[idx][field] = value;
                                      setPaymentMethods(updated);
                                    };
                                    
                                    const handleSplitChange = (index, value) => {
                                      const updated = [...paymentMethods];
                                      const val = parseFloat(value) || 0;
                                      updated[index].split = val;
                                    
                                      const percentageRows = updated.filter(p => p.isPercentage);
                                    
                                      if (percentageRows.length > 1) {
                                        const totalExcludingLast = percentageRows
                                          .slice(0, -1)
                                          .reduce((acc, p) => acc + (parseFloat(p.split) || 0), 0);
                                    
                                        const lastIdx = [...updated]
                                          .map((p, i) => ({ ...p, index: i }))
                                          .filter(p => p.isPercentage)
                                          .pop()?.index;
                                    
                                        if (lastIdx !== undefined) {
                                          updated[lastIdx].split = Math.max(0, 100 - totalExcludingLast);
                                        }
                                      }
                                    
                                      setPaymentMethods(updated);
                                    };
                                    
                        
                                    const toggleSplitType = (index, isPercent) => {
                                      const updated = [...paymentMethods];
                                      updated[index].isPercentage = isPercent;
                                      setPaymentMethods(updated);
                                    };
                  
                                     const handleUpdatePaymentMethos = () => {
                                                          const totalPercentage = paymentMethods
                                                              .filter(p => p.isPercentage)
                                                              .reduce((acc, p) => acc + (p.split || 0), 0);
                                    
                                                          if (totalPercentage !== 100) {
                                                              ToastRef.current.notify(["error", "Total split percentage must equal 100%."]);
                                                              return;
                                                          }
                                    
                                                          // 2. Validate BSB format (6 digits)
                                                          const invalidBSB = paymentMethods.find(
                                                              p => p.method !== 2 && (!/^\d{6}$/.test(p.bsb || ""))
                                                          );
                                    
                                                          if (invalidBSB) {
                                                              ToastRef.current?.notify(["error", "Each BSB must be exactly 6 digits."]);
                                                              return;
                                                          }
                                    
                                                        const payload = {
                                                          FolioCode: onwerFolioDetails.ownerAccountFolio,
                                                          OwnerPaymentMethodDetails: paymentMethods.map((pm) => ({
                                                            Id: 0,
                                                            PaymentMethod: pm.method,
                                                            ChequePayeeName: pm.method === 2 ? pm.payee : null,
                                                            AccountName: pm.method === 2 ? null : pm.payee,
                                                            AccountBSB: pm.method === 2 ? null : pm.bsb,
                                                            AccountNumber: pm.method === 2 ? null : pm.account,
                                                            BpayPayee: "",
                                                            BillerCode: "",
                                                            Split: pm.split,
                                                            SplitType: pm.isPercentage ? 1 : 2
                                                          }))
                                                        };
                                                      
                                                        makeRequestWithSpinner(showSpinner, hideSpinner, addupdatepaymentmethod, "post", payload)
                                                          .then((res) => {
                                                            if (res.status === 1) {
                                                              ToastRef.current.notify(["success", res.message]);
                                                              cancel();
                                                            } else {
                                                              ToastRef.current.notify(["error", res.message]);
                                                            }
                                                          })
                                                          .catch(() => {
                                                            ToastRef.current.notify(["error", "Something went wrong."]);
                                                          });
                                                      };

                                                      const columns1 = [
                                                        {
                                                          title: "Fee Template",
                                                          dataIndex: "FeeTemplateName",
                                                        },
                                                        {
                                                          title: "Income Account",
                                                          dataIndex: "Account",
                                                        },
                                                        {
                                                          title: "Fee Trigger",
                                                          dataIndex: "FeeTrigger",
                                                        },
                                                        {
                                                          title: "Notes",
                                                          dataIndex: "Notes",
                                                        },
                                                        {
                                                          title: "Amount",
                                                          dataIndex: "Amount",
                                                          render: (val, record, idx) => (
                                                            <Input
                                                              style={{ width: 100 }}
                                                              value={val}
                                                              onChange={(e) => {
                                                                const updated = [...folioFees];
                                                                updated[idx].Amount = parseFloat(e.target.value);
                                                                setFolioFees(updated);
                                                              }}
                                                              prefix={record.calculationType === 2 ? "$" : "%"}
                                                            />
                                                          ),
                                                        },
                                                        {
                                                          title: "Action",
                                                          render: (_, record, idx) => (
                                                            <DeleteOutlined
                                                              style={{ color: "red", cursor: "pointer" }}
                                                              onClick={() => handleRemoveFee(idx)}
                                                            />
                                                          ),
                                                        },
                                                      ];

                                                      const columns2 = [
                                                        {
                                                          title: "Method",
                                                          dataIndex: "method",
                                                          render: (value, row, idx) => (
                                                            <Select
                                                              style={{ width: "100%" }}
                                                              value={value}
                                                              onChange={(val) => updateField(idx, "method", val)}
                                                            >
                                                              {ePaymentModes.map((mode) => (
                                                                <Option key={mode.value} value={mode.value}>
                                                                  {mode.label}
                                                                </Option>
                                                              ))}
                                                            </Select>
                                                          ),
                                                        },
                                                        {
                                                          title: "Payee",
                                                          dataIndex: "payee",
                                                          render: (value, row, idx) => (
                                                            <Input value={value} onChange={(e) => updateField(idx, "payee", e.target.value)} />
                                                          ),
                                                        },
                                                        {
                                                          title: "BSB",
                                                          dataIndex: "bsb",
                                                          render: (value, row, idx) => (
                                                            <Input
                                                              maxLength={6}
                                                              value={row.bsb}
                                                              onChange={(e) => {
                                                                const val = e.target.value;
                                                                // Allow only digits
                                                                if (/^\d{0,6}$/.test(val)) {
                                                                  updateField(idx, "bsb", val);
                                                                }
                                                              }}
                                                              status={row.bsb && row.bsb.length !== 6 ? "error" : ""}
                                                            />
                                                          ),
                                                        },
                                                        {
                                                          title: "Account #",
                                                          dataIndex: "account",
                                                          render: (value, row, idx) => (
                                                            <Input value={value} onChange={(e) => updateField(idx, "account", e.target.value)} />
                                                          ),
                                                        },
                                                        {
                                                          title: "Split",
                                                          dataIndex: "split",
                                                          render: (value, row, idx) => {
                                                            const isLast = idx === paymentMethods.length - 1;
                                                            const isPercentageCount = paymentMethods.filter((p) => p.isPercentage).length;
                                                            const isReadOnly = row.isPercentage && isPercentageCount > 1 && isLast;
                                                    
                                                            return (
                                                              <Space>
                                                                <Tooltip title="%">
                                                                  <Button
                                                                    icon={<PercentageOutlined />}
                                                                    type={row.isPercentage ? "primary" : "default"}
                                                                    onClick={() => toggleSplitType(idx, false)}
                                                                  />
                                                                </Tooltip>
                                                                <Tooltip title="$">
                                                                  <Button
                                                                    icon={<DollarOutlined />}
                                                                    type={!row.isPercentage ? "primary" : "default"}
                                                                    onClick={() => toggleSplitType(idx, true)}
                                                                  />
                                                                </Tooltip>
                                                                <Input
                                                                  type="number"
                                                                  style={{ width: 100 }}
                                                                  value={value}
                                                                  readOnly={isReadOnly}
                                                                  onChange={(e) => handleSplitChange(idx, e.target.value)}
                                                                />
                                                              </Space>
                                                            );
                                                          },
                                                        },
                                                        {
                                                          title: "Action",
                                                          render: (_, __, idx) => (
                                                            <DeleteOutlined style={{color:'red'}} onClick={() => handleRemovePaymentMethod(idx)}/>
                                                          ),
                                                        },
                                                      ];
                                                    
                                                    
  return (
    <div>
      <div style={{ width: "100%" }} className="mt-2 mb-2">
      <ToastAlert ref={ToastRef} />

        <ToggleTabs
          tabs={tabs}
          onTabChange={handleTabChange1}
          externalTabValue={tabValue}
        />
      </div>
      {tabValue === "ownership" && (
        <div style={{ paddingTop: "10px" }}>
          <form onSubmit={handleSubmit}>
            <div>
              {values.owners.map((owner, index) => (
                <Collapse
                  id={index}
                  title={`Owner ${index + 1}`}
                  data={
                    <div className="row">
                      {/* Contact Selection */}
                      <div className="col-lg-6 col-sm-12">
                        <label className="s1">Contacts</label>
                        <div style={{ display: "flex" }}>
                          <Select
                            style={{ width: "100%", height: "40px" }}
                            placeholder="Search for contacts"
                            labelInValue
                            showSearch
                            filterOption={false}
                            onSearch={debounceFetcher}
                            notFoundContent={
                              fetching ? <Spin size="small" /> : null
                            }
                            options={option}
                            onChange={(label, value) =>
                              handleSearchChange(label, [value], index)
                            }
                            defaultValue={selectedValues}
                            allowClear
                          />
                        </div>
                      </div>
                      <SelectBox
                        label="Type"
                        placeholder="Select Type"
                        name={`owners[${index}].type`}
                        options={typeData}
                        value={
                          values.owners[index]
                            ? values.owners[index].type
                            : null
                        }
                        onChange={(val) =>
                          handleOwnerChange(index, "type", val.value)
                        }
                      />

                      <SelectBox
                        label="Title"
                        placeholder="Select Title"
                        name={`owners[${index}].title`}
                        options={titleData}
                        value={
                          values.owners[index]
                            ? values.owners[index].title
                            : null
                        }
                        onChange={(val) =>
                          handleOwnerChange(index, "title", val.value)
                        }
                      />

                      <TextBox
                        label="First Name"
                        placeholder="First Name"
                        name={`owners[${index}].firstName`} // Name must match the Formik field path
                        value={
                          values.owners[index]
                            ? values.owners[index].firstName
                            : ""
                        }
                        onChange={(e) =>
                          handleOwnerChange(index, "firstName", e.target.value)
                        }
                        error={errors.owners && errors.owners[index]?.firstName}
                        touched={
                          touched.owners && touched.owners[index]?.firstName
                        }
                      />

                      <TextBox
                        label="Last Name"
                        placeholder="Last Name"
                        name={`owners[${index}].lastName`}
                        value={
                          values.owners[index]
                            ? values.owners[index].lastName
                            : ""
                        }
                        onChange={(e) =>
                          handleOwnerChange(index, "lastName", e.target.value)
                        }
                        error={errors.owners && errors.owners[index]?.lastName}
                        touched={
                          touched.owners && touched.owners[index]?.lastName
                        }
                      />

                      {/* Phone */}
                      <TextBox
                        label="Phone"
                        placeholder="Phone"
                        name={`owners[${index}].phone`}
                        value={
                          values.owners[index] ? values.owners[index].phone : ""
                        }
                        onChange={(e) =>
                          handleOwnerChange(index, "phone", e.target.value)
                        }
                        error={errors.owners && errors.owners[index]?.phone}
                        touched={touched.owners && touched.owners[index]?.phone}
                        icon={<BiPhone height="100%" width="100%" />}
                      />

                      {/* Email */}
                      <TextBox
                        label="Email"
                        placeholder="Email"
                        name={`owners[${index}].email`}
                        value={
                          values.owners[index] ? values.owners[index].email : ""
                        }
                        onChange={(e) =>
                          handleOwnerChange(index, "email", e.target.value)
                        }
                        error={errors.owners && errors.owners[index]?.email}
                        touched={touched.owners && touched.owners[index]?.email}
                        icon={<BiEnvelope height="100%" width="100%" />}
                      />

                      {/* Address Input */}
                      <AddressInput
                        labelName="Address"
                        address={
                          values.owners[index]
                            ? values.owners[index].ownerShipAddress
                            : ""
                        }
                        setAddress={(value) =>
                          handleOwnerChange(index, "ownerShipAddress", value)
                        }
                      />
                      <TextBox
                          label="ABN"
                          placeholder="ABN Number"
                          name={`owners[${index}].abn`}
                          value={values.owners[index]?.abn || ""}
                          onChange={(e) => handleOwnerChange(index, "abn", e.target.value)}
                          onBlur={(e) => handleABNLoopup(e.target.value, index)}
                          error={errors.owners && errors.owners[index]?.abn}
                          touched={touched.owners && touched.owners[index]?.abn}
                        />
                        <TextBox
                          label="Company Name"
                          placeholder="Company Name"
                          name={`owners[${index}].companyName`}
                          value={values.owners[index]?.companyName || ""}
                          readOnly={true}
                          error={errors.owners && errors.owners[index]?.companyName}
                          touched={touched.owners && touched.owners[index]?.companyName}
                        />

                      <div className="mt-3 col-lg-4 mb-3 d-flex align-items-center">
                        <Checkbox
                          checked={
                            values.owners[index]
                              ? values.owners[index].isPrimary
                              : false
                          }
                          onChange={(e) =>
                            handleOwnerChange(
                              index,
                              "isPrimary",
                              e.target.checked
                            )
                          }
                        />
                        
                        <label
                          className="ml-2"
                          htmlFor={`primary-owner-${index}`}
                        >
                          Set as primary
                        </label>
                      </div>
                      <div className="col-lg-12 mt-2 text-right">
                        {index !== 0 && ( // Ensure the delete button is not displayed for the first owner
                          <button
                            type="button"
                            className="btn"
                            style={{ background: "white", border: "1px solid gray", color: "gray" }}
                            onClick={() => handleDeleteOwner(index)}
                          >
                            <DeleteOutlined
                              style={{
                                fontSize: "16px",
                                cursor: "pointer",
                                marginRight: "5px",
                              }}
                              title="Delete Owner"
                            />
                            Delete Owner
                          </button>
                        )}
                      </div>

                    </div>
                  }
                />
              ))}
            </div>

            <div className="add-owner-btn1 mt-3" onClick={handleAddOwner1}>
              <PlusOutlined className="plus-icon1" />
              <span className="span1">Add Another Owner</span>
            </div>

            <div className="property-details-buttons">
              <button className="pdb-cancel" type="reset" onClick={cancel}>
                Cancel
              </button>
              <button className="pdb-save-changes" type="button" onClick={handleSubmit}>
                Next
              </button>
            </div>
          </form>
        </div>
      )}
      {tabValue === "agreement" ? (
        <div>
          <Table
            dataSource={recentSalesData}
            columns={columns}
            pagination={false}
          />

          <div className="property-details-buttons">
            <button
              className="pdb-save-changes"
              type="button"
              onClick={handleAgreementNext}
            >
              Next
            </button>
          </div>
          <CustomModal
            title="Preview"
            width={600}
            closable={closePreview}
            visible={isModalVisible}
            onCancel={closePreview}
            footer={null}
            modalData={
              <div
                className="row"
                style={{ marginTop: "30px", marginLeft: "10px" }}
              >
                {documentUrl && (
                  <iframe
                    src={documentUrl}
                    width="100%"
                    height="600px"
                    title="Document Viewer"
                  />
                )}
              </div>
            }
          />
        </div>
      ) : null}
      {tabValue === "folio" ? (
        <div>
          <div style={{ borderBottom: '1px solid #e9ecef', padding: '10px' }}>
            <div className="col-lg-8">
              <span
                className={`col-lg-2 col-sm-2 stat-item ${purpose === 1 ? 'active' : ''}`}
                onClick={() => handleStatClick(1)}
              >
                Details
              </span>
              <span
                className={`col-lg-2 col-sm-2 stat-item ${purpose === 2 ? 'active' : ''}`}
                onClick={() => handleStatClick(2)}
              >
                Fees 
              </span>
              <span
                className={`col-lg-4 col-sm-2 stat-item ${purpose === 3 ? 'active' : ''}`}
                onClick={() => handleStatClick(3)}
              >
                Payment Method
              </span>
            </div>
            {purpose === 1 ?
            <div>
              <Collapse
                id={"Disburse"}
                title={"Disburse"}
                data={
                  <div className="row" style={{ padding: "0px 30px" }}>
                    <div className='s1'>When should this folio be disbursed?</div>
                    <TextBox label="When total money in is" placeholder="Enter amount" name="totalMoneyLimit" value={ownerFolioDetails.totalMoneyLimit} onChange={(e) => setOwnerFolioDetails({ ...ownerFolioDetails, totalMoneyLimit: e.target.value })} extraData={"or more"} />
                    <TextBox label="When balance is" placeholder="Enter balance" name="balanceLimit" value={ownerFolioDetails.balanceLimit} onChange={(e) => setOwnerFolioDetails({ ...ownerFolioDetails, balanceLimit: e.target.value })} extraData={"or more"} />
                    <SelectBox options={eFeeCaluclationTypeOptions} label="At regular intervals" value={eFeeCaluclationTypeOptions.find((opt) => opt.value === parseInt(ownerFolioDetails.disbursementIntervel))} onChange={(val) => setOwnerFolioDetails({ ...ownerFolioDetails, disbursementIntervel: val.value })} />
                    <TextBox label="Next disburse date" type="date" placeholder="Select date" name="nextDisbursementDate" value={ownerFolioDetails.nextDisbursementDate?.split("T")[0]} onChange={(e) => setOwnerFolioDetails({ ...ownerFolioDetails, nextDisbursementDate: e.target.value })} extraData={"28th or later will be rounded to the end of the month"} />
                  </div>
                } />
              <Collapse
                id={"Withhold"}
                title={"Withhold"}
                data={
                  <div className="row" style={{ padding: "0px 30px" }}>
                    <TextBox colVal={12} label="Withhold amount" placeholder="Amount" name="withholdAmount" value={ownerFolioDetails.withholdAmount} onChange={(e) => setOwnerFolioDetails({ ...ownerFolioDetails, withholdAmount: e.target.value })} extraData={"At the time of disbursement, this amount will be discounted from the funds disbursed to the owner and withheld. If there is less than this amount available to be disbursed no funds will be disbursed and the amount will stay in the owner's folio."} />
                    <TextBox colVal={12} label="Withhold reason" placeholder="Reason" name="withholdReason" value={ownerFolioDetails.withholdReason} onChange={(e) => setOwnerFolioDetails({ ...ownerFolioDetails, withholdReason: e.target.value })} />
                  </div>
                } />
              <Collapse
                id={"Withhold"}
                title={"Withhold"}
                data={
                  <div className="col-lg-4" style={{ padding: "0px 30px" }}>
                    <label className="s1">Owner access</label>
                    <ToggleTabs tabs={clientAccesstabs} onTabChange={(val) => setOwnerFolioDetails({ ...ownerFolioDetails, clientAccess: val === 1 })} externalTabValue={ownerFolioDetails.clientAccess ? 1 : 0} />
                  </div>
                } />
            </div> : purpose === 2 ? 
                <div>
                  <Table
                    className="fee-table"
                    columns={columns1}
                    dataSource={folioFees.map((f, i) => ({ ...f, key: i }))}
                    pagination={false}
                  />

                  {/* Draft Rows */}
                  {draftRows.map((row, idx) => (
                    <div key={`draft-${idx}`} style={{ display: "flex", gap: 8, padding: "10px 0" }}>
                      <Select
                        placeholder="Select template"
                        style={{ width: 200 }}
                        options={feeTemplates.map((t) => ({ label: t.label, value: t, ...t }))}
                        value={row.feeTemplate?.label}
                        onChange={(val, option) => handleFeeTemplateSelect(idx, option)}
                      />
                      <Input disabled value={row.feeTemplate?.account || ""} style={{ width: 150 }} />
                      <Input disabled value={row.feeTemplate?.sFeeType || ""} style={{ width: 150 }} />
                      <Input placeholder="Enter note" style={{ width: 150 }} />
                      <Input
                        placeholder="Amount"
                        style={{ width: 120 }}
                        value={row.amount}
                        prefix={row.feeTemplate?.calculationType === 2 ? "$" : "%"}
                        onChange={(e) => {
                          const updated = [...draftRows];
                          updated[idx].amount = e.target.value;
                          setDraftRows(updated);
                        }}
                      />
                      <Space>
                        <CheckOutlined
                          style={{ color: "green", fontSize: 18 }}
                          onClick={() => handleSaveDraftRow(idx)}
                        />
                        <CloseOutlined
                          style={{ color: "red", fontSize: 18 }}
                          onClick={() => handleRemoveFee(idx, "draft")}
                        />
                      </Space>
                    </div>
                  ))}

                  <Button
                    type="dashed"
                    icon={<PlusOutlined />}
                    onClick={handleAddNewDraftRow}
                    style={{ marginTop: 16 }}
                  >
                    Add
                  </Button>
                </div> :  
                <Table
        columns={columns2}
        dataSource={paymentMethods.map((item, index) => ({ ...item, key: index }))}
        pagination={false}
        footer={() => (
          <div style={{ textAlign: "right" }}>
            <Button icon={<PlusOutlined />} type="dashed" onClick={handleAddPaymentMethod}>
              Add
            </Button>
          </div>
        )}
      />}
          </div> 
          <div className="property-details-buttons">
            <button className="pdb-cancel" type="reset" onClick={handleCancel}>
              Cancel
            </button>
            <button
              className="pdb-save-changes"
              type="button"
              onClick={purpose === 1 ? handleUpdatePropertyOwnerfolio : purpose === 2 ? handleUpdatePropertyOwnerfolioFee : handleUpdatePaymentMethos}
            >
              Next
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PropertyOwnerShip;
